export default __webpack_public_path__ + "static/media/tv2.f1a462fb.gif";